import Link from '../components/elements/link';
import SubTitle from '../components/elements/sub-title';
import Title from '../components/elements/title';
import UnorderedList from '../components/elements/unordered-list';
import { CONTACT_EMAIL } from '../constants';
import { FREE_SHIPPING_TRESHOLD } from '../constants';

export const TermsOfSaleFr = () => {
  return (
    <div>
      <Title>Conditions de vente</Title>
      <p className="my-2">Dernière mise à jour le 2 juin 2021</p>
      <p className="my-2">
        Ces conditions de vente régissent l'utilisation du site web de Gypsy Mode, identifié par le numéro d'entreprise
        BE.0830.868.445 et dont le siège social est situé à la Jan Hijoensstraat 7, 8800 Roeselare (ci-après dénommé "le
        vendeur").
      </p>
      <p className="my-2">
        Les conditions de vente s'appliquent chaque fois qu'une commande est passée via la boutique en ligne de Gypsy de
        Saint Tropez.
      </p>
      <p className="my-2">
        Le site web a été créé sur commande et est géré par Gypsy Mode. Toute personne passant une commande sur le site
        (ci-après dénommée "le client") confirme, en passant commande, être une personne physique majeure et capable de
        contracter.
      </p>
      <p className="my-2">
        Les personnes incapables de contracter doivent être représentées par leur représentant légal, qui est également
        lié par ces conditions de vente et doit remplir le formulaire de commande lui-même ou obtenir une autorisation
        explicite de la personne incapable de contracter.
      </p>
      <p className="my-2">
        Passer une commande implique une obligation de paiement et constitue une acceptation explicite de ces conditions
        générales de vente, qui sont publiées sur le site web et sont incluses dans la confirmation de commande.
        L'acceptation des conditions générales est nécessaire pour passer une commande. En passant commande, vous
        déclarez connaître et accepter les conditions générales du vendeur. Nous livrons en Belgique et aux Pays-Bas.
        Les conditions générales sont toujours disponibles et consultables sur le site web. À chaque commande, les
        conditions générales en vigueur sur le site web et dans la confirmation de commande sont applicables, à
        l'exclusion de toutes dispositions éventuellement plus anciennes ou plus récentes. Si l'une de ces conditions
        est invalide pour quelque raison que ce soit, les autres conditions restent pleinement applicables.
      </p>
      <p className="my-2">
        Ce qui n'est pas expressément défini dans ces conditions générales de vente est régi par les dispositions du
        droit belge. La langue des accords conclus est le néerlandais. En cas de doute, vous pouvez toujours contacter
        le service client.
      </p>
      <SubTitle>Offre et commande</SubTitle>
      <UnorderedList>
        <p className="my-2">
          Nous décrivons aussi complètement et précisément que possible ce que nous vendons. Les images sont une
          représentation fidèle des marchandises proposées.
        </p>
        <p className="my-2">
          La commande est complète et l'accord entre nous est définitif dès que nous confirmons votre commande par
          e-mail et dès que nous recevons l'approbation de l'émetteur de la carte pour votre transaction de paiement.
          Nous acceptons Visa, MasterCard, Apple Pay, Bancontact et iDeal. Si l'émetteur de votre carte refuse
          d'approuver votre paiement, nous ne pouvons pas être tenus responsables des retards dans la livraison et/ou de
          la non-livraison de votre commande. Les commandes sans paiement valide au nom du titulaire de la carte
          enregistré ne seront ni acceptées ni traitées.
        </p>
        <p className="my-2">
          Pour acheter un produit, vous ajoutez le produit à votre panier. Ensuite, vous saisissez vos coordonnées de
          contact et de facturation. Ensuite, vous choisissez votre mode de livraison : livraison à l'adresse de votre
          choix ou retrait en magasin. Dans la dernière étape, vous obtenez une page de récapitulation, vous acceptez
          nos conditions générales et confirmez votre paiement en appuyant sur le bouton de commande. Une fois que vous
          avez suivi ces étapes, votre achat est définitif.
        </p>
        <p className="my-2">
          Le délai de livraison ne commence qu'après réception du paiement. Nous nous efforçons de livrer dans les plus
          brefs délais possibles. Le délai de livraison est d'au moins 1 jour ouvrable et au maximum de 30 jours après
          réception du paiement pour la livraison. Le vendeur n'est pas responsable des retards ou de la non-livraison
          dus au transporteur.
        </p>
        <p className="my-2">
          Nos prix incluent toutes les taxes, la TVA et les taxes. Les frais d'expédition ne sont pas inclus.
        </p>
        <p className="my-2">Les livraisons en point retrait sont gratuites à partir de {FREE_SHIPPING_TRESHOLD} euros.</p>
      </UnorderedList>
      <SubTitle>Paiement</SubTitle>
      <UnorderedList>
        <p className="my-2">Nous n'acceptons que les paiements par le mode de paiement sur notre site web.</p>
        <p className="my-2">
          Pour garantir un paiement en ligne sécurisé et la sécurité de vos données personnelles, nous utilisons Mollie,
          pour plus d'informations,{' '}
          <Link href="https://www.mollie.com/en/features/security" isExternal>
            cliquez ici
          </Link>
          .
        </p>
      </UnorderedList>
      <SubTitle>Livraison</SubTitle>
      <UnorderedList>
        <p className="my-2">Nous ferons preuve de la plus grande diligence dans l'exécution des commandes.</p>
        <p className="my-2">
          Les commandes passées seront expédiées avec le service que vous avez choisi dans les 24 heures. En périodes
          plus chargées, comme les soldes ou les nouvelles collections, des retards peuvent survenir. Si vous passez
          commande le week-end ou un jour férié, la commande sera traitée le premier jour ouvrable suivant.
        </p>
        <p className="my-2">
          Nos envois sont sous notre responsabilité jusqu'à leur livraison chez vous ou chez le représentant que vous
          avez désigné. Si vous nous retournez des marchandises dans les 14 jours suivant l'achat, vous êtes responsable
          du transport.
        </p>
        <p className="my-2">
          Si les marchandises que nous avons livrées ont été endommagées pendant le transport ou ne correspondent pas
          aux articles que vous avez commandés, vous devez nous en informer dès que possible et nous renvoyer les
          articles dans les 14 jours calendaires suivant l'achat.
        </p>
        <p className="my-2">
          Nous ne pouvons être tenus responsables de tout dommage causé par un retard de livraison ou une non-livraison
          par le transporteur. Notre responsabilité est limitée dans de tels cas à la valeur des articles dont il est
          prouvé qu'ils n'ont pas été reçus par le client.
        </p>
      </UnorderedList>
      <SubTitle>Retour</SubTitle>
      <UnorderedList>
        <p className="my-2">
          Lorsque vous achetez des biens, vous avez le droit de décider dans les 14 jours suivant la livraison si vous
          souhaitez conserver ou non les biens (le cachet de la poste faisant foi). Veuillez nous contacter d'abord à
          l'adresse
          {CONTACT_EMAIL} en indiquant votre numéro de commande, la date et votre nom. Une fois que nous aurons confirmé
          le retour, vous pourrez renvoyer votre commande. Dans les 14 jours suivant la réception de votre commande,
          nous vous rembourserons le prix d'achat complet, hors frais d'expédition.
        </p>
        <p className="my-2">Nous attendrons de recevoir les marchandises avant de procéder au remboursement.</p>
        <p className="my-2">
          Vous pouvez renvoyer vos articles jusqu'à 14 jours après la livraison, à vos frais, avec le service de
          messagerie de votre choix. Tout retour est à la charge de l'acheteur. Nous vous recommandons d'utiliser un
          service de suivi et de conserver la preuve d'expédition. Nous ne sommes pas responsables des colis perdus lors
          d'un retour.
        </p>
        <p className="my-2">
          En tout état de cause, un retour n'est accepté que si l'article est étiqueté, non souillé, non endommagé, non
          porté et dans son emballage d'origine.
        </p>
        <p className="my-2">
          Les articles achetés pendant la période des soldes, les articles en solde, les ventes exceptionnelles (comme
          les soldes, les ventes, le Black Friday, les promotions spéciales, etc.) ainsi que les articles faisant
          l'objet d'une promotion ne peuvent pas être échangés ni retournés.
        </p>
        <p className="my-2">
          En cas de non-respect de ces directives, le produit retourné est considéré comme non conforme à notre
          politique de retour et ne sera ni échangé ni remboursé.
        </p>
      </UnorderedList>
      <SubTitle>Propriété intellectuelle</SubTitle>
      <p className="my-2">
        Notre site web, nos logos, nos textes, nos photos, nos noms et en général toute notre communication sont
        protégés par des droits de propriété intellectuelle, qu'ils nous appartiennent, à nos fournisseurs ou à d'autres
        ayants droit.
      </p>
      <p className="my-2">
        Il est interdit d'utiliser et/ou de modifier les droits de propriété intellectuelle tels que décrits dans cet
        article. Par exemple, vous ne pouvez pas copier ou reproduire des dessins, des photos, des noms, des textes, des
        logos, des combinaisons de couleurs, etc., sans notre autorisation écrite préalable et explicite.
      </p>
      <SubTitle>Protection de la vie privée</SubTitle>
      <p className="my-2">
        En passant une commande, le client déclare avoir pris connaissance de la politique de confidentialité du
        vendeur. La politique de confidentialité du vendeur contient les informations nécessaires sur la manière dont
        les données personnelles sont traitées, à quelle fin et quelles cookies sont utilisés.
      </p>
      <p className="my-2">
        Pour exercer son droit d'accès, de modification ou de suppression des données personnelles, le client peut
        contacter le service client conformément à la procédure décrite dans la politique de confidentialité du vendeur.
        Le client peut également modifier ses propres données via son profil de compte.
      </p>
      <SubTitle>Compétence et droit applicable</SubTitle>
      <p className="my-2">
        Cette convention est soumise aux dispositions du droit belge. En cas de litige, seuls les tribunaux de
        l'arrondissement de Courtrai, en Belgique, sont compétents.
      </p>
    </div>
  );
};
